<template>
  <div
    class="
      px-3
      py-3
      grey
      lighten-4
      rounded
      d-none d-sm-flex
      flex-row
      align-center
    "
  >
    <div class="d-flex align-center">
      <div v-for="(item, i) in breadcrumbItems" :key="i" class="mr-2">
        <v-btn
          :disabled="item.disabled"
          :to="item.to"
          text
          plain
          class="
            pa-0
            secondary--text
            subtitle-1
            text-sm-body-1
            font-weight-regular
            button1
          "
          >{{ item.text }}
        </v-btn>
        <span class="ml-2 grey--text font-weight-regular" v-if="!item.disabled"
          >/</span
        >
      </div>
    </div>

    <!-- <div
        class="
          ml-auto
          secondary--text
          subtitle-1
          text-sm-body-1
          font-weight-regular
          d-none d-md-block
        "
        v-if="currentRoute != 'new' && userRole == 'credit'"
      >
        Τελευταία έκδοση: {{ currentReportDate }}
      </div> -->

    <div
      class="
        ml-auto
        secondary--text
        subtitle-1
        text-sm-body-1
        font-weight-regular
        d-none d-md-block
      "
      v-if="
        (userRole == 'hcmc' || userRole == 'viewer') &&
        hcmcReportDate !== undefined
      "
    >
      Τελευταία έκδοση:
      {{
        new Date(currentHcmcReport.lastUploadedVersionDate).toLocaleDateString(
          "el"
        )
      }}
      {{
        padTo2Digits(
          new Date(currentHcmcReport.lastUploadedVersionDate).getHours()
        ) +
        ":" +
        padTo2Digits(
          new Date(currentHcmcReport.lastUploadedVersionDate).getMinutes()
        )
      }}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  created() {
    console.log(this.hcmcReportDate);
  },
  computed: {
    ...mapState({
      userRole: (state) => state.auth.userRole,
      currentRoute: (state) => state.reports.currentRoute,
      currentHcmcReport: (state) => state.hcmcreports.currentHcmcReport,
    }),
    ...mapGetters([
      "currentReportDate", //"currentHcmcReportDate"//
    ]),
  },
  props: ["breadcrumbItems", "hcmcReportDate"],

  methods: {
    padTo2Digits(num) {
      return String(num).padStart(2, "0");
    },
  },
};
</script>

<style scoped  lang="scss" >
</style>